import { Box, Text } from '@factorialco/deprecated-design-system'
import { WorkingConditionVersionApplicationFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import ContractTooltip from 'modules/contracts/components/ContractDetails/ContractTooltip'
import WorkingConditionValue from 'modules/contracts/components/ContractDetails/WorkingConditionValue'

interface Props {
  id: string
  title: string
  description?: string
  tooltip?: string
  workingConditionVersionApplication?: WorkingConditionVersionApplicationFragment
}

const Item = ({ id, title, description, tooltip, workingConditionVersionApplication }: Props) => {
  const fields = workingConditionVersionApplication?.fields
  const workingConditionItem = workingConditionVersionApplication?.version.items.find(
    (item) => item.name === id
  )

  const renderDescription = () => {
    if (!description) {
      return (
        <Text size="300" weight="medium" color="grey600">
          {i18n.t('contract_versions.time.not_informed')}
        </Text>
      )
    }

    if (workingConditionItem && workingConditionVersionApplication) {
      return (
        <WorkingConditionValue
          value={description}
          workingConditionName={workingConditionVersionApplication.version.name}
          workingConditionItem={workingConditionItem}
          fields={fields}
        />
      )
    }

    return (
      <Text size="300" weight="medium" color="grey1000">
        {description}
      </Text>
    )
  }

  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 4 }} gap="s8">
      <Box flexDirection="row" gap="s4" alignItems="center">
        <Text size="200" weight="normal" color="grey800">
          {title}
        </Text>
        {tooltip && <ContractTooltip information={tooltip} icon="info-circle-line" />}
      </Box>
      {renderDescription()}
    </Box>
  )
}

export default observer(Item)
